import Icon from '@common/components/icon';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CompanyValueEmpty = () => {
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-flex-col tw-gap-3 company-value-empty tw-p-5
      tw-border tw-border-gray-200 tw-border-solid
      tw-rounded-md tw-bg-gray-50 tw-text-gray-600"
    >
      <Icon type="crown" />
      <div className="tw-text-gray-600">
        {t('organisation:company_values_empty_content')}
      </div>
    </div>
  );
};

export default CompanyValueEmpty;
